<template>
  <div>
    <div class="pb-2">
      <h1 class="title title--h1 first-title title__separate">Contact</h1>
    </div>
    <div>
      <p>Open for opportunities: <strong style="color: #1e73be;">Yes</strong></p>
      <h2 class="title title--h3">Contact Form</h2>
      <form id="contact-form" name="contact-form" method="post" class="contact-form" @submit.prevent="handleSubmit">
        <div class="row">
          <div class="form-group col-12 col-md-6">
            <input
              type="text"
              id="name"
              name="name"
              v-model="form.name"
              placeholder="Full name"
              class="form-control"
            >
          </div>
          <div class="form-group col-12 col-md-6">
            <input
              type="email"
              id="email"
              name="email"
              v-model="form.email"
              placeholder="Email address"
              class="form-control"
            >
          </div>
          <div class="form-group col-12 col-md-12">
            <textarea
              id="message"
              name="message"
              v-model="form.message"
              placeholder="Your message"
              rows="4"
              class="textarea form-control"
            ></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 order-2 order-md-1 text-center text-md-left">
            <span v-if="submitStatus === 'success'" class="text-success">Message sent successfully!</span>
            <span v-if="submitStatus === 'error'" class="text-danger">Something went wrong. Please try again.</span>
          </div>
          <div class="col-12 col-md-6 order-1 order-md-2 text-right">
            <button type="submit" class="btn" :disabled="submitting">
              <em class="font-icon icon-send"></em> {{ submitting ? 'Sending...' : 'Submit' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      },
      submitStatus: null,
      submitting: false
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.form.name || !this.form.email || !this.form.message) {
        this.submitStatus = 'error'
        return
      }
      this.submitting = true
      this.submitStatus = null
      try {
        const res = await fetch('https://formsubmit.co/ajax/a92031be91bdd6181bb162dc7d394e9f', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            name: this.form.name,
            email: this.form.email,
            message: this.form.message,
            _subject: `Portfolio Contact: ${this.form.name}`
          })
        })
        if (res.ok) {
          this.submitStatus = 'success'
          this.form = { name: '', email: '', message: '' }
        } else {
          this.submitStatus = 'error'
        }
      } catch {
        this.submitStatus = 'error'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
